import {IPrevSearchState, ISearchState, UpdatePrevSearchAction} from "../../types/redux/search";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export const prevSearchSlice = createSlice({
  name: UpdatePrevSearchAction,
  initialState: {
    document: null,
    bibliography: null
  },
  reducers: {
    setPrevDocumentSearchState: (state: IPrevSearchState, action: PayloadAction<ISearchState>) => {
      state.document = {...action.payload}
    },

    clearPrevDocumentSearchState: (state: IPrevSearchState) => {
      state.document = null;
    },

    setPrevBibliographySearchState: (state: IPrevSearchState, action: PayloadAction<ISearchState>) => {
      state.bibliography = {...action.payload}
    },

    clearPrevBibliographySearchState: (state: IPrevSearchState) => {
      state.bibliography = null;
    }
  }
});

export const {
  setPrevDocumentSearchState,
  clearPrevDocumentSearchState,
  setPrevBibliographySearchState,
  clearPrevBibliographySearchState
} = prevSearchSlice.actions;
export default prevSearchSlice.reducer;
